/* Kocktail — lid reveal: scroll-scrubbed image sequence.
   As the tall [data-kx-lid] section scrolls past its sticky stage, the frame
   index advances and a progress bar fills. Uses getBoundingClientRect + rAF
   (robust to whatever element scrolls). Self-guards.

   Frames are hard-cut, never cross-faded — see the note on .kx-lid__frame in
   kocktail-lid-reveal.liquid. Smoothness comes from the number of frames, not
   from blending between them. */
(function () {
  function init() {
    var sec = document.querySelector('[data-kx-lid]');
    if (!sec) return;
    var frames = sec.querySelectorAll('.kx-lid__frame');
    var bar = sec.querySelector('.kx-lid__bar-fill');
    var n = frames.length;
    if (!n) return;

    /* Reduced motion: a scroll-scrubbed image sequence is exactly the kind of
       motion this setting asks us to drop. Show the end state — lid off, which
       is the point the sequence is making — and never start the loop. The rest
       of the Kocktail scripts (reveal, chrome, quotes) already honour this. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var f = 0; f < n; f++) frames[f].style.opacity = f === n - 1 ? '1' : '0';
      if (bar) bar.style.width = '100%';
      return;
    }

    // The markup renders frame 1 visible and the rest at opacity 0.
    var shown = 0;
    var barPct = -1;
    var running = false;
    var warmed = false;

    /* Where the sequence starts, as a share of the viewport height: p hits 0
       when the section's top edge is this far down the screen. 0 would mean
       "not until the section fills the screen", which is where this used to
       begin. */
    var lead = parseFloat(sec.getAttribute('data-kx-lid-start'));
    if (!isFinite(lead)) lead = 25;
    lead = Math.min(Math.max(lead, 0), 90) / 100;

    /* The mobile hold-off. On phones the section is shorter than the viewport,
       so it takes the second branch below, which used to begin scrubbing at the
       instant the section's top edge crossed the bottom of the screen — the lid
       was already coming away before you could see the glass. This is how far
       the section has to travel up the screen, as a share of viewport height,
       before the peel starts at all. */
    var mLead = parseFloat(sec.getAttribute('data-kx-lid-start-mobile'));
    if (!isFinite(mLead)) mLead = 45;
    mLead = Math.min(Math.max(mLead, 0), 90) / 100;

    /* Decode every frame before it is first cut to. The browser fetches these
       eagerly enough (they are in the viewport, just transparent), but it
       defers decoding an image it has never painted — so the first cut to a
       given frame can paint nothing for a beat. At scroll speed that blank
       beat reads as a flash. decode() does that work off the main thread
       while the section is still approaching. */
    function warm() {
      if (warmed) return;
      warmed = true;
      for (var i = 0; i < n; i++) {
        var img = frames[i];
        if (img.decode) { img.decode().catch(function () {}); }
      }
    }

    function update() {
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight;

      if (!warmed && r.bottom > -vh && r.top < vh * 2) warm();

      var total = r.height - vh;
      var p;
      if (total > 0) {
        /* Progress is measured against the section's whole journey up the
           screen, not just the part of it where the stage is pinned.

             p = 0 when the section's top edge is `lead` down the viewport
             p = 1 when the section's bottom edge reaches the viewport bottom

           The old version started at the moment the section filled the screen,
           so the approach was dead scroll and then the whole sequence had to
           fit into the shorter pinned window. Starting during the approach
           means the peel begins as the top of the glass — the end the lid is
           on — first comes into view, and it tracks where you are on the page
           the whole way down. The finish is unchanged: it lands exactly as the
           stage unpins. */
        var startTop = vh * lead;
        var endTop = vh - r.height;
        var span = startTop - endTop;
        p = span > 0 ? (startTop - r.top) / span : 0;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
      } else {
        // Section shorter than the viewport — on mobile it is a normal band, not
        // a full-screen sticky, so there is no "scrolled into" distance. Scrub on
        // how far it has travelled up through the viewport instead, finishing a
        // little before it leaves so the lid is fully off while still in view.
        //
        // `hold` is dead scroll at the front: nothing happens until the section
        // has climbed that far up the screen, so the glass is properly in view —
        // sealed — before the lid starts to lift. The travel distance shrinks by
        // the same amount, so the sequence still finishes in the same place.
        var hold = vh * mLead;
        var travel = r.height + vh * 0.6 - hold;
        var moved = vh - r.top - hold;
        p = travel > 0 ? Math.min(Math.max(moved, 0), travel) / travel : 0;
      }

      var idx = Math.min(n - 1, Math.max(0, Math.round(p * (n - 1))));

      /* Two writes per change, not 2n writes per animation frame. The old loop
         set an inline opacity on every frame 60 times a second whether or not
         anything had changed, and that constant style invalidation is its own
         source of stutter. */
      if (idx !== shown) {
        frames[shown].style.opacity = '0';
        frames[idx].style.opacity = '1';
        shown = idx;
      }
      if (bar) {
        var pct = Math.round(p * 100);
        if (pct !== barPct) { bar.style.width = pct + '%'; barPct = pct; }
      }

      running = r.bottom > 0 && r.top < vh * 1.5;
      if (running) requestAnimationFrame(update);
    }
    function kick() { if (!running) { running = true; requestAnimationFrame(update); } }

    running = true;
    requestAnimationFrame(update);
    ['scroll', 'wheel', 'touchmove'].forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true, capture: true });
    });
    window.addEventListener('resize', kick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
